// extracted by mini-css-extract-plugin
export default {"wrapper":"ImprovementsSelector_wrapper__CxjNz","item":"ImprovementsSelector_item__RTrd5"};